import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';

const StageList = ({ stages, handleOpenUpdateDialog, handleDelete, handleReplicate }) => {
  const navigate = useNavigate();

  const handleMissionClick = (stageId) => {
    navigate(`${stageId}/mission`);
  };

  return (
    <table className="table">
      <thead className='table-head'>
        <tr>
          <th>S. No.</th>
          <th>Name</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
      {Array.isArray(stages.stages) && stages.stages.map((stage) => (
          <tr key={stage.stage_id}>
            <td>{stage.stage_id}</td>
            <td>{stage.stage_name}</td>
            <td>
              <Button variant="contained" className="mr-2 g-but" onClick={() => handleOpenUpdateDialog(stage)}>
                Edit
              </Button>
              <Button variant="contained" className="mr-2 b-but" onClick={() => handleMissionClick(stage.stage_id)}>
                Mission/Battle
              </Button>
              <Button variant="contained" className="mr-2 y-but" onClick={() => handleDelete(stage.stage_id)}>
                Delete
              </Button>
              <Button variant="contained" className="mr-2 r-but" onClick={() => handleReplicate(stage.stage_id)}>
                Replicate
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default StageList;
